/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Base logic for counts by item for listables
 */

export const CountsByType = {
  minPrice: {},
  bedrooms: {},
}

export default {
  fromJS: (data) => {
    if (data) {
      return {
        minPrice: data.minPrice || data.min_price,
        bedrooms: data.bedrooms,
      }
    }
    return CountsByType
  },
}
